import { apiClient } from '../config/api';

// FEAT-065 — premium area placement (web client).

export interface PremiumPlacement {
  id: string;
  zip: string;
  city: string | null;
  state: string | null;
  expiresAt: string;
}

export interface PremiumCheckoutResult {
  placementId: string;
  checkoutUrl: string;
  expiresAt: string;
}

interface PremiumPlacementsResponse {
  success: boolean;
  data: PremiumPlacement[];
}

interface PremiumCheckoutResponse {
  success: boolean;
  data: PremiumCheckoutResult;
}

class PremiumPlacementService {
  async listPlacements(): Promise<PremiumPlacement[]> {
    const response = await apiClient.get<PremiumPlacementsResponse>(
      '/caregivers/me/premium-placements',
    );
    if (!response.data.success) {
      throw new Error('Failed to load premium placements');
    }
    return response.data.data;
  }

  async checkout(serviceAreaId: string): Promise<PremiumCheckoutResult> {
    const response = await apiClient.post<PremiumCheckoutResponse>(
      '/caregivers/me/premium-placements/checkout',
      { serviceAreaId },
    );
    if (!response.data.success) {
      throw new Error('Failed to start premium checkout');
    }
    return response.data.data;
  }
}

export const premiumPlacementService = new PremiumPlacementService();
